<div class="sidebar" [class.open]="isOpen">
  <!-- Sidebar Header with Logo -->
  <div class="sidebar-header" style="display: flex; justify-content: space-between; align-items: center;">
    <img routerLink="/accueil" src="../../../assets/acceuil/educanetlogo.png" alt="Educanet" class="sidebar-logo">
    <!-- Language Selector -->
    <div class="relative language-dropdown">
      <button
        (click)="toggleLanguageDropdown()"
        class="flex items-center space-x-1 text-[#009A90] hover:text-orange-500 font-medium"
      >
        <img
          [src]="getCurrentLanguageFlag()"
          alt="{{ currentLanguage | uppercase }}"
          class="w-6 h-4 object-cover rounded-sm"
        />
        <span class="text-xs">&#x25BE;</span>
      </button>
      <div
        *ngIf="isLanguageDropdownOpen"
        class="absolute top-full right-0 mt-2 w-44 bg-white rounded-lg shadow-lg z-[9999] border border-gray-200"
      >
        <div class="py-2">
          <button
            (click)="selectLanguage('en')"
            class="flex items-center w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
          >
            <img
              src="https://flagcdn.com/w20/gb.png"
              alt="English"
              class="w-6 h-4 object-cover rounded-sm mr-3"
            />
            English
          </button>
          <button
            (click)="selectLanguage('fr')"
            class="flex items-center w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
          >
            <img
              src="https://flagcdn.com/w20/fr.png"
              alt="French"
              class="w-6 h-4 object-cover rounded-sm mr-3"
            />
            Français
          </button>
          <button
            (click)="selectLanguage('ar')"
            class="flex items-center w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
          >
            <img
              src="https://flagcdn.com/w20/tn.png"
              alt="Arabic"
              class="w-6 h-4 object-cover rounded-sm mr-3"
            />
            العربية
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- User Profile Section -->
  <div class="user-profile">
    <div class="user-info">
      <img [src]="parentPhoto" alt="Profile" class="profile-avatar">
      <div class="logout-button-container">
        <img src="../../../assets/Logout.png" class="sidebar-button" (click)="onLogout()">
      </div>
      <span class="user-name">{{ parentName }}</span>
      <span class="user-role">Parent</span>
    </div>
  </div>

  <div class="sidebar-content">

    <!-- Acceil -->
    <div class="category-section">
      <div class="category-title" (click)="navigateTo('/accueil')">
        <img src="../../../assets/acceuil/Icons/accueil.png" alt="Admin" class="category-icon">
        <span>{{ 'navigation.home' | translate }}</span>
      </div>
    </div>

    <!-- Communication -->
    <div class="category-section">
      <div class="category-title" (click)="toggleCategory('communication')">
        <img src="../../../assets/acceuil/Icons/Communication Icon.png" alt="Communication" class="category-icon">
        <span>{{ 'sidebar.communication' | translate }}</span>
        <span class="arrow" [class.rotated]="isCommunicationOpen">▼</span>
      </div>
      <div class="category-items" [class.expanded]="isCommunicationOpen">
        <div class="menu-item" (click)="navigateTo('/observation')" [class.selected]="selectedRoute === '/observation'">
          <span>{{ 'navigation.observations' | translate }}</span>
        </div>
        <div class="menu-item" (click)="navigateTo('/cahierdetext')" [class.selected]="selectedRoute === '/cahierdetext'">
          <span>{{ 'accueil.Cahierdetexte' | translate }}</span>
        </div>
        <div class="menu-item" (click)="navigateTo('/avis')" [class.selected]="selectedRoute === '/avis'">
          <span>{{ 'accueil.opinions' | translate }}</span>
        </div>
        <div class="menu-item" (click)="navigateTo('/messagerie')" [class.selected]="selectedRoute === '/messagerie'">
          <span>{{ 'navigation.messaging' | translate }}</span>
        </div>
        <div class="menu-item" (click)="navigateTo('/rdvparental')" [class.selected]="selectedRoute === '/rdvparental'">
          <span>{{ 'accueil.rdvParental' | translate }}</span>
        </div>
        <div class="menu-item" (click)="navigateTo('/discipline')" [class.selected]="selectedRoute === '/discipline'">
          <span>{{ 'accueil.discipline' | translate }}</span>
        </div>
        <div class="menu-item" (click)="navigateTo('/documents')" [class.selected]="selectedRoute === '/documents'">
          <span>{{ 'accueil.documents' | translate }}</span>
        </div>
      </div>
    </div>

    <!-- Gestion Administrative -->
    <div class="category-section">
      <div class="category-title" (click)="toggleCategory('administrative')">
        <img src="../../../assets/acceuil/Icons/Gestion Admin Icons.png" alt="Admin" class="category-icon">
        <span>{{ 'sidebar.administrativeManagement' | translate }}</span>
        <span class="arrow" [class.rotated]="isAdministrativeOpen">▼</span>
      </div>
      <div class="category-items" [class.expanded]="isAdministrativeOpen">
        <div class="menu-item" (click)="navigateTo('/event')" [class.selected]="selectedRoute === '/event'">
          <span>{{ 'navigation.events' | translate }}</span>
        </div>
        <div class="menu-item" (click)="navigateTo('/emploi')" [class.selected]="selectedRoute === '/emploi'">
          <span>{{ 'emploi.title' | translate }}</span>
        </div>
        <div class="menu-item has-icon" (click)="navigateTo('/contine')" [class.selected]="selectedRoute === '/contine'">
          <span>{{ 'canteen.title' | translate }}</span>
        </div>
        <div class="menu-item" (click)="navigateTo('/carnet')" [class.selected]="selectedRoute === '/carnet'">
          <span>{{ 'carnet.title' | translate }}</span>
        </div>
        <div class="menu-item" (click)="navigateTo('/paiement')" [class.selected]="selectedRoute === '/paiement'">
          <span>{{ 'payments.title' | translate }}</span>
        </div>
        <div class="menu-item" (click)="navigateTo('/note')" [class.selected]="selectedRoute === '/note'">
          <span>{{ 'note.title' | translate }}</span>
        </div>
      </div>
    </div>

    <!-- Univers Enfant -->
    <div class="category-section">
      <div class="category-title" (click)="toggleCategory('universEnfant')">
        <img src="../../../assets/acceuil/Icons/Univers Enfants Icon.png" alt="Univers Enfant" class="category-icon">
        <span>{{ 'sidebar.childUniverse' | translate }}</span>
        <span class="arrow" [class.rotated]="isUniversEnfantOpen">▼</span>
      </div>
      <div class="category-items" [class.expanded]="isUniversEnfantOpen">
        <div *ngIf="showDelice" class="menu-item" (click)="navigateTo('/kissati')" [class.selected]="selectedRoute === '/kissati'">
          <span>{{ 'navigation.stories' | translate }}</span>
        </div>
        <div class="menu-item" (click)="navigateTo('/infoenfant')" [class.selected]="selectedRoute === '/infoenfant'">
          <span>{{ 'accueil.childrenInfo' | translate }}</span>
        </div>
        <div class="menu-item" (click)="navigateTo('/albums')" [class.selected]="selectedRoute === '/albums'">
          <span>{{ 'photos.title' | translate }}</span>
        </div>
        <div *ngIf="showDelice" class="menu-item" (click)="navigateTo('/conseilDelice')" [class.selected]="selectedRoute === '/conseilDelice'">
          <!-- example icon; replace path with real delice icon if available -->
          <img src="../../../assets/icons/delice.png" alt="delice" class="inline-block w-4 h-4 mr-2" *ngIf="showDelice" />
          <span>{{ 'accueil.deliceAdvice' | translate }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Dynamic Sidebar Ads (only when delice enabled) -->
  <ng-container *ngIf="showDelice">
    <div class="sidebar-image-section" *ngFor="let ad of sidebarAds">
      <ng-container *ngIf="ad.href; else imgOnly">
        <a [href]="ad.href" target="_blank" rel="noopener">
          <img [src]="ad.pathimage || ad.imageUrl" alt="Sidebar Ad" class="sidebar-image">
        </a>
      </ng-container>
      <ng-template #imgOnly>
        <img [src]="ad.pathimage || ad.imageUrl" alt="Sidebar Ad" class="sidebar-image">
      </ng-template>
      <p class="image-phrase" *ngIf="ad.titre">{{ ad.titre }}</p>
      <p class="image-description" *ngIf="ad.description">{{ ad.description }}</p>
    </div>
  </ng-container>

  <!-- Contact -->
  <div class="category-section">
    <div class="category-title" (click)="navigateTo('/contact')">
      <img src="../../../assets/contact.jfif" alt="Admin" class="category-icon rounded-lg">
      <span>{{ 'footer.contact' | translate }}</span>
    </div>
  </div>

</div>

<!-- Toggle Button with E Logo -->
<div class="sidebar-toggle-btn" [class.sidebar-closed]="!isOpen" (click)="toggleSidebar()">
  <div class="toggle-btn-content">
    <i class="fas fa-bars menu-icon"></i>
  </div>
</div>